(function () {
  'use strict';

  if (window.UnifiedTrackingConfig) {
    return;
  }

  const CONFIG = {
    version: '2.1.1',

    deployment: 'bybianchi',

    environment: 'production',

    debug: false,

    consentRequired: true,

    consent: {
      manager: 'UnifiedConsent',
      failClosed: true
    },

    providers: {
      ga4: {
        enabled: true,
        measurementId: 'G-6V4KDM872B'
      },

      clarity: false,
      meta: false,
      tiktok: false,
      linkedin: false
    },

    events: {
      section_view: {
        category: 'engagement',
        service: 'dynamic',
        conversion: false
      },

      cta_click: {
        category: 'engagement',
        service: 'dynamic',
        conversion: false
      },

      phone_click: {
        category: 'lead',
        service: 'dynamic',
        conversion: true
      },

      email_click: {
        category: 'lead',
        service: 'dynamic',
        conversion: true
      },

      whatsapp_click: {
        category: 'lead',
        service: 'dynamic',
        conversion: true
      },

      contact_form_submit: {
        category: 'lead',
        service: 'dynamic',
        conversion: true
      },

      newsletter_signup: {
        category: 'nurture',
        service: 'dynamic',
        conversion: false
      },

      article_share: {
        category: 'engagement',
        service: 'journal',
        conversion: false
      },

      social_click: {
        category: 'engagement',
        service: 'dynamic',
        conversion: false
      }
    },

    pages: {
      brand: {
        paths: [
          '/'
        ]
      },

      story: {
        paths: []
      },

      bianca: {
        paths: []
      },

      atelier: {
        paths: [
          '/pages/atelier'
        ]
      },

      event_planner: {
        paths: [
          '/pages/event-planner'
        ]
      },

      projects: {
        paths: [
          '/pages/signature'
        ]
      },

      journal: {
        paths: []
      },

      contact: {
        paths: [
          '/pages/contact'
        ]
      },

      shop: {
        paths: []
      }
    },

    phones: {
      contact: {
        display: '0754 407 902',

        normalized: [
          '0754407902',
          '40754407902'
        ]
      }
    },

    emails: {
      general: {
        display: 'contact@bybianchi.ro',

        normalized: [
          'contact@bybianchi.ro'
        ]
      }
    },

    contactForm: {
      selector:
        'form.bianchi-contact-main__form',

      subjectField:
        'contact[Subiect]',

      messageField:
        'contact[body]',

      phoneField:
        'contact[Telefon]',

      emailField:
        'contact[email]',

      partnerField:
        'contact[Nume partener]',

      eventDateField:
        'contact[Data evenimentului]',

      guestCountField:
        'contact[Numar invitati]',

      locationField:
        'contact[Locatie]',

      budgetField:
        'contact[Buget aproximativ]',

      topics: {
        'event-planner':
          'event_planner',

        'wedding-planner':
          'event_planner',

        'marturii':
          'marturii',

        'signature':
          'marturii',

        'atelier':
          'atelier',

        'colaborare':
          'general',

        'altceva':
          'general'
      }
    },

    newsletter: {
      forms: {
        footer: {
          selector:
            'form.bianchi-footer__form',

          service:
            'brand'
        },

        journal: {
          selector:
            'form.bianchi-journal-newsletter__form',

          service:
            'journal'
        }
      }
    },

    articleShare: {
      containerSelector:
        '.bianchi-article-content__share',

      excludeMailtoFromLeadTracking:
        true
    },

    visibility: {
      selector:
        '[data-ut-section]',

      threshold:
        0.5,

      trackOnce:
        true
    },

    rules: {
      enabled: true,

      defaultDecision:
        'allow',

      definitions: []
    }
  };

  window.UnifiedTrackingConfig =
    CONFIG;

  if (CONFIG.debug) {
    console.info(
      '[Unified Config] Bianchi configuration initialized',
      {
        version:
          CONFIG.version,

        deployment:
          CONFIG.deployment,

        environment:
          CONFIG.environment,

        consentRequired:
          CONFIG.consentRequired,

        configuredEvents:
          Object.keys(
            CONFIG.events
          ).length,

        configuredPages:
          Object.keys(
            CONFIG.pages
          ).length,

        enabledProviders:
          Object.keys(
            CONFIG.providers
          ).filter(
            function (provider) {
              const value =
                CONFIG.providers[
                  provider
                ];

              return (
                value === true ||
                (
                  value &&
                  typeof value ===
                    'object' &&
                  value.enabled ===
                    true
                )
              );
            }
          )
      }
    );
  }
})();